export default __webpack_public_path__ + "static/media/smartway-partner.d3a28f8d.png";